define(function (require) {
	const tpl = require('./templates/t_itv_label.hbs');
	const baseElement = require('./v_itv_base_element');
	return baseElement.extend({
		template: tpl,
		className: function () {
			var baseClass = baseElement.prototype.className.apply(this);
			return baseClass+' label-container';
		},
		initialize: function (options) {
		},
		templateHelpers: function () {
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);
			var ret = {
				//if the label has a bind, then we only display values. if there's no value, it will be blank. otherwise, display the text as we received it.
				text: () =>{
					var text = '';
					if (this.model.get('bind') && this.model.get('bind').length > 0) {
						text = this.model.get('value') != null ? this.model.get('value') : ''; 
					} else {
						text = this.model.get('text');
					}
					return text;
				},
				classes: 'field' + (this.model.get('isEnabled')===false ? ' disabled' : '')
			};

			ret = $.extend({}, baseTH, ret);
			return ret;
		},
		getData: function () {
			return null;
		},
	});
});